import StyledLevel from '@/components/RubricsPortfolioComponents/StyledLevel';
import LevelTitle from '@/components/RubricsPortfolioComponents/StyledLevel/LevelTitle';
import LevelDescription from '@/components/RubricsPortfolioComponents/StyledLevel/LevelDescription';
import { type Level as LevelType } from '@/lib/types';
import LevelAttachments from './LevelAttachments';

type LevelProps = {
  level: LevelType;
};

const Level = ({ level }: LevelProps) => (
  <StyledLevel>
    {level.title && <LevelTitle>{level.title}</LevelTitle>}
    <LevelDescription>{level.description}</LevelDescription>
    <LevelAttachments level={level} />
  </StyledLevel>
);

export default Level;
